import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Button, Col, Row, Pagination, Modal } from 'react-bootstrap';
import Search from '../../components/Search';
import { FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';

export function Empresas() {
    const [isLoading, setIsLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);
    const [nivelAcesso, setNivelAcesso] = useState(0);

    useEffect(() => {
        api.get('nivel-acesso', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then((response: any) => {
            setNivelAcesso(response.data.nivel)
        })
    }, [])
    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    // const currentEmployees = employees.slice(indexOfFirstEmployee, indexOfLastEmployee);

    // Verifica se 'employees' é um array antes de filtrar
    const filteredEmployees = Array.isArray(employees) ? employees.filter((employee: any) => {
        const cpfClean = employee.cnpj.replace(/[\.-]/g, ''); // Remove '.' e '-'

        return (
            employee.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
            cpfClean.includes(searchQuery) ||
            employee.id.toString().includes(searchQuery)
        );
    }) : []; // Retorna um array vazio se 'employees' não for um array
    const [show, setShow] = useState(false);
    const [modalReset, setModalReset] = useState(false);
    const [idSelected, setIdSelected] = useState('');

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const handleClose = () => { setShow(false); setModalReset(false); }

    const showModal = (id: any) => {
        setIdSelected(id)
        setShow(true)
    }

    const showModalReset = (id: any) => {
        setIdSelected(id);
        setModalReset(true);
    }

    const handleConfirmReset = async () => {
        try {
            await api.put(`empresas/reiniciar/${idSelected}`);
            const response = await api.get('empresas');
            setEmployees(response.data);
            setAlert({ show: true, message: 'Tempo reiniciado com sucesso!', variant: 'success' });
        } catch (error) {
            setAlert({ show: true, message: 'Erro ao excluir item', variant: 'danger' });
        }
        handleClose();
    }

    const handleConfirm = async () => {
        try {
            await api.delete(`empresas/deletar/${idSelected}`);
            const response = await api.get('empresas')
            setEmployees(response.data);
            setAlert({ show: true, message: 'Item excluído com sucesso!', variant: 'success' });
        } catch (error) {
            setAlert({ show: true, message: 'Erro ao excluir item', variant: 'danger' });
        }
        handleClose();
    };

    useEffect(() => {
        const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
        const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
        const newCurrentFilteredEmployees = filteredEmployees.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

        setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    }, [currentPage, employeesPerPage, filteredEmployees]);

    // Function to load companies
    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setCompanies(response.data.message ? [] : response.data);
            setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
        } catch (error) {

            console.log(error)
            setAlert({ show: true, message: 'Erro ao carregar as empresas', variant: 'danger' });

        } finally {
            setIsLoading(false);
        }
    };
    const loadEmployees = async () => {
        try {
            const response = await api.get('empresas')
            console.log("🚀 ~ loadEmployees ~ response:", response.data)
            setEmployees(response.data);
        } catch (error) {
            // setAlert({ show: true, message: 'Erro ao carregar as empresas', variant: 'danger' });
        }
    };

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };
    // Load companies initially
    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        loadEmployees();
    }, [selectedCompany]); // Carregar funcionários quando a empresa selecionada for alterada

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage == null || currentPage == undefined || currentPage == 0 ? (
                    0
                ) : (
                    currentPage
                )}
            </Pagination.Item>
        );


        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };


    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleConfirm}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={modalReset} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de Restart de Tempo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Você tem certeza que deseja reiniciar o tempo dessa empresa?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleConfirmReset}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Empresas" />

                        {nivelAcesso !== 2 && (
                            <Col md={8} className='newbutton'>
                                <Button className='btn-main' href={`empresas/cadastrar`}><FillPlus /> Nova Empresa</Button>
                            </Col>
                        )}
                        <Col md={4}>
                            <Search placeHolder="Procure pela Razão Social ou CNPJ" onChange={handleSearchChange} />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            {employees.length && employeesPerPage ? (
                                <span>Página {currentPage} de {Math.ceil(employees.length / employeesPerPage)}</span>
                            ) : (
                                <span>Página {currentPage} de 0</span>
                            )}


                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead style={{ backgroundColor: '#007bff', color: 'white' }}>
                                            <tr className="table-row-empresas">
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>CÓD</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>CNPJ</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Razão Social</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Observação</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentFilteredEmployees.length > 0 ? (
                                                currentFilteredEmployees.map((employee: any) => {
                                                    let expirado: boolean = false;
                                                    if (employee.pgrUsuario && employee.pgrUsuario.end_time) {
                                                        const date = new Date(employee.pgrUsuario.end_time);
                                                        expirado = date < new Date();
                                                    }
                                                    return (
                                                        <tr key={employee.id} className="table-row-empresas">
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderBottom: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                                {employee.id}
                                                            </td>
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderBottom: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                                {employee.cnpj}
                                                            </td>
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderBottom: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                                {employee.nome}
                                                            </td>
                                                            <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderBottom: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                                {employee.obs && employee.obs != '' ? employee.obs : '-'}
                                                            </td>
                                                            <td style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal', borderBottom: '1px solid lightgray' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                                    <a href={`empresas/editar/${employee.id}`} style={{ textDecoration: 'none', color: '#007bff', border: '1px solid #007bff', padding: '5px 10px', borderRadius: '4px', display: 'inline-block' }}>
                                                                        Editar
                                                                    </a>
                                                                    {nivelAcesso === 4 && (
                                                                        <>
                                                                            {expirado && (
                                                                                <button
                                                                                    onClick={() => showModalReset(employee.id)}
                                                                                    style={{ marginLeft: '10px', backgroundColor: 'transparent', border: '1px solid #007bff', color: '#007bff', padding: '5px 10px', borderRadius: '4px', display: 'inline-block' }}>
                                                                                    Reiniciar tempo
                                                                                </button>
                                                                            )}

                                                                            <button
                                                                                onClick={() => showModal(employee.id)}
                                                                                style={{ marginLeft: '10px', backgroundColor: 'transparent', border: '1px solid red', color: 'red', padding: '5px 10px', borderRadius: '4px', display: 'inline-block' }}>
                                                                                Excluir
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={5} style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}